/**
 * @file コンポーネント：症例スライダー スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { mediaQuery } from "~/src/styles/mixins";

// スタイル
export const StyledSlider = styled.div`
    position: relative;

    /* 画像サイズ */
    .swiper-slide img {
        width: 100%;
        height: auto;
    }

    /* 矢印ボタン共通 */
    .swiper-button-prev, .swiper-button-next {
        position: absolute;
        top: 50%;
        width: 44px;
        height: 44px;
        background: rgba(0, 0, 0, 0.5); /* 半透明の黒い丸背景 */
        border-radius: 50%; /* 丸いボタン */
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    /* SVG を背景に前へ矢印を描画 */
    .swiper-button-prev {
        left: 15px;
        background-image: url('data:image/svg+xml;charset=utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" fill="white"/></svg>');
        background-size: 50%;
        background-repeat: no-repeat;
        background-position: center;
    }

    /* SVG を背景に次へ矢印を描画 */
    .swiper-button-next {
        right: 15px;
        background-image: url('data:image/svg+xml;charset=utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z" fill="white"/></svg>');
        background-size: 50%;
        background-repeat: no-repeat;
        background-position: center;
    }

    /* ページ位置表示をカスタマイズ */
    .swiper-pagination {
        position: relative !important;
        margin-top: 20px !important;
    }
`;

export const StyledOperationWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;
